import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

const MainLayout = ({ children }) => {

  return (
    <main className="main-wrapper">
      <Header />
        {children}
      <Footer />
    </main>
  );
};

export default MainLayout; 